// extracted by mini-css-extract-plugin
export var content = "BackgroundImage-module--content--ecc1b";
export var hemXVideoWrapper = "BackgroundImage-module--hemXVideoWrapper--b7664";
export var img = "BackgroundImage-module--img--389e4";
export var imgDesktop = "BackgroundImage-module--img-desktop--d6a68";
export var imgMobile = "BackgroundImage-module--img-mobile--a0dfa";
export var overlay = "BackgroundImage-module--overlay--aad4e";
export var video = "BackgroundImage-module--video--41c65";
export var videoWrapper = "BackgroundImage-module--video-wrapper--5572b";
export var wrapper = "BackgroundImage-module--wrapper--ef5d4";